import React from 'react';
import { ImportSource } from '../../graphql/generated/graphql';
import Link from '../../utils/router/Link';
import ImportFileModal from './ImportFileModal';

interface NotionImportModalProps {
  close: () => void;
}

const NotionImportModal = ({ close }: NotionImportModalProps) => (
  <ImportFileModal
    close={close}
    source={ImportSource.Notion}
    uploaderInfo="Upload the zip file from Notion's HTML export"
    footer={
      <Link
        to="https://go.slab.com/importing-all-your-content-from-notion"
        newTab
      >
        How do I export from Notion?
      </Link>
    }
  />
);

export default NotionImportModal;
